// store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './userSlice';
import cartReducer from './cartSlice';
import wholesaleCartReducer from './wholeSaleCartSlice';
import loaderReducer from './loaderSlice';
import currencyReducer from './currencySlice';
import checkoutReducer from './checkoutSlice';

const rootReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  wholesaleCart: wholesaleCartReducer,
  loader: loaderReducer,
  currency: currencyReducer,
  checkout: checkoutReducer,
});

const persistConfig = {
  key: 'silvergem-root',
  storage,
  migrate: async (state) => {
    if (!state) return state;

    if (state.user === null) {
      state.user = {
        isLoggedIn: false,
        userInfo: null,
      };
    }

    return state;
  },
  whitelist: ['user', 'cart', 'checkout', 'currency'], // ← currency added
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);